import request from '@/plugins/axios'

// 采集分类列表
export const apiCollectionLists = (params: any) => request.get('/shop.collection/lists', {params})

// 添加采集分类
export const apiCollectionAdd = (params: any) => request.post('/shop.collection/add', params)

// 采集分类详情
export const apiCollectionDetail = (params: any) => request.get('/shop.collection/detail', {params})

// 编辑采集分类
export const apiCollectionEdit = (params: any) => request.post('/shop.collection/edit', params)

// 删除采集分类
export const apiCollectionDel = (params: any) => request.post('/shop.collection/delete', params)
